module Meevo.Plugins.EmployeeCategories {
  "use strict";

  /**
  * Main Section of Employee Category
  */
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.EmployeeCategory> {

    /**
  * Base class override which defines what a DEFAULT model looks like.
  */
    createSectionModelInstance(postAdd:(data:any)=>any): void {
      this.dataService.getTemplate(this.baseEndpoint).then((data) => {
        this.model = data;
      });
    }
   
    hotkeyRegEx: RegExp = new RegExp("^[A-Za-z]+$");
  }

}